import { z } from "zod";

export const WysslingRequestSchema = z.object({
  userGradients: z.array(z.number().positive()).optional(),
});

export type WysslingRequest = z.infer<typeof WysslingRequestSchema>;
